module.exports = __webpack_public_path__ + "static/media/banner.4d319424.jpg";